import React from "react"
import PropTypes from "prop-types"
import { Grid, CmsImage } from "@bw/bits"
import { Pagination, Teaser, TeaserList } from "@bw/partials"
import Article from "../../../models/article"

const ListOfArticles = ({ numberOfColumns, articles, location }) => {
  const items = React.useMemo(() => {
    if (articles.length === 0) {
      return []
    }

    return articles.map(item => {
      let author = undefined
      if (item.authors && item.authors.length > 0) {
        author = {
          name: item.authors[0]?.name,
          image: item.authors[0]?.avatar?.url ? (
            <CmsImage
              src={item.authors[0]?.avatar?.url}
              alt={item.authors[0]?.name || ""}
            />
          ) : null,
        }
      }
      return numberOfColumns > 1 ? (
        <Teaser
          key={item.id}
          suptitle={item.getDate()}
          title={item.title}
          excerpt={item.teaserExcerpt}
          image={
            item.teaserImage ? (
              <CmsImage
                src={item.teaserImage}
                alt={item.teaserImage?.alt || item.title}
              />
            ) : null
          }
          to={item.url}
          author={author}
        />
      ) : (
        <TeaserList
          key={item.id}
          to={item.url}
          suptitle={item.getDate()}
          title={item.title}
          subtitle={item.teaserExcerpt}
        />
      )
    })
  }, [articles, numberOfColumns])

  if (items.length === 0) {
    return null
  }

  return (
    <Pagination columns={numberOfColumns} items={items} location={location} />
  )
}

ListOfArticles.propTypes = {
  numberOfColumns: PropTypes.number,
  articles: PropTypes.arrayOf(PropTypes.instanceOf(Article)),
}

ListOfArticles.defaultProps = {
  numberOfColumns: 3,
  articles: [],
}

export { ListOfArticles }
